import getLinkHref from '@/modules/utils/api/getLinkHref'
import clientHTTP from '@/modules/clientHTTP'

const getSoftwares = (application) => {
  return clientHTTP.get(getLinkHref(application, 'softwares'))
}

const createSoftware = (application, params = {}) => {
  return clientHTTP.put(getLinkHref(application, 'softwares'), params)
}

const deleteSoftware = (application, name) => {
  return clientHTTP.delete(getLinkHref(application, 'softwares') + '?fileName=' + name)
}

export default {
  getSoftwares,
  createSoftware,
  deleteSoftware
}
